( function( $, moment ) {
    "use strict";

    var _events = {
        onChangeEntryQuantity: function() {
            var $quantity = $(this),
                $row = $quantity.closest('tr'),
                $bookingEntries = $row.closest('[data-booking-entries]'),
                $id = $row.find('[data-form-control="id"]'),
                $overall = $row.find('[data-form-control="overall"]'),
                $previousOverall = $row.find('[data-form-control="previous_overall"]'),
                $lastOverall = $row.find('[data-form-control="last_overall"]'),
                $saleTickets = $row.find('[data-sale-tickets]'),
                quantity = $quantity.val(),
                overall = $overall.val() || $overall.attr('placeholder'),
                maxQuantity = $saleTickets.data('sale-tickets') - overall;

            if ($lastOverall.val() !== '') {
                maxQuantity = $saleTickets.data('sale-tickets') - $lastOverall.val();
            }

            if (! /^\-?\d+$/.test(quantity)
                || quantity > maxQuantity
                || ($previousOverall.length && parseInt($previousOverall.val()) + parseInt(quantity) < 0)
            ) {
                quantity = '';
            }

            if (quantity === '') {
                if ($id.val() === '') {
                    $quantity.val('');
                    $overall.val('');
                } else {
                    quantity = $quantity.attr('placeholder');
                    $quantity.val(quantity);
                }
            }

            if (quantity !== '') {
                $overall.val(parseInt($previousOverall.val()) + parseInt(quantity));
            }

            $bookingEntries.trigger('refresh');
        },

        onChangeEntryOverall: function() {
            var $overall = $(this),
                $row = $overall.closest('tr'),
                $bookingEntries = $row.closest('[data-booking-entries]'),
                $id = $row.find('[data-form-control="id"]'),
                $quantity = $row.find('[data-form-control="quantity"]'),
                $previousOverall = $row.find('[data-form-control="previous_overall"]'),
                $lastOverall = $row.find('[data-form-control="last_overall"]'),
                $saleTickets = $row.find('[data-sale-tickets]'),
                overall = $overall.val(),
                maxOverall = $saleTickets.data('sale-tickets');

            if ($lastOverall.val() !== '') {
                maxOverall = parseInt($quantity.attr('placeholder')) + parseInt($previousOverall.val()) + ($saleTickets.data('sale-tickets') - $lastOverall.val());
            }

            if (! /^\d+$/.test(overall) || overall > maxOverall) {
                overall = '';
            }

            if (overall === '') {
                if ($id.val() === '') {
                    $overall.val('');
                    $quantity.val('');
                } else {
                    overall = parseInt($quantity.attr('placeholder')) + parseInt($previousOverall.val());
                    $overall.val(overall);
                }
            }

            if (overall !== '') {
                $quantity.val(parseInt(overall) - parseInt($previousOverall.val()));
            }

            $bookingEntries.trigger('refresh');
        },

        onRefreshBookingEntries: function() {
            var $bookingEntries = $(this),
                $quantityInputs = $bookingEntries.find('[data-form-control="quantity"]'),
                $overallInputs = $bookingEntries.find('[data-form-control="overall"]'),
                $previousQuantityInputs = $bookingEntries.find('[data-form-control="previous_quantity"]'),
                $previousOverallInputs = $bookingEntries.find('[data-form-control="previous_overall"]'),
                $saleTickets = $bookingEntries.find('[data-sale-tickets]'),
                $bookingQuantity = $bookingEntries.find('[data-booking-quantity]'),
                $bookingOverall = $bookingEntries.find('[data-booking-overall]'),
                $bookingPreviousQuantity = $bookingEntries.find('[data-booking-previous-quantity]'),
                $bookingPreviousOverall = $bookingEntries.find('[data-booking-previous-overall]'),
                $bookingSaleTickets = $bookingEntries.find('[data-booking-sale-tickets]'),
                $bookingProgress = $bookingEntries.find('[data-booking-progress]'),
                $entryProgress = $bookingEntries.find('[data-entry-progress]'),
                quantitiesSum = 0,
                overallsSum = 0,
                bookingQuantity = 0,
                bookingOverall = 0,
                bookingSaleTickets = 0;

            $quantityInputs.each(function() {
                var $quantity = $(this),
                    quantity = $quantity.val() === '' ? 0 : parseInt($quantity.val());

                quantitiesSum += quantity;
            });

            $bookingQuantity.text(quantitiesSum);

            $overallInputs.each(function() {
                var $overall = $(this),
                    overall = $overall.val() === '' ? $overall.attr('placeholder') : $overall.val();

                overallsSum += parseInt(overall);
            });

            $bookingOverall.text(overallsSum);

            $previousQuantityInputs.each(function() {
                var $previousQuantity = $(this),
                    previousQuantity = $previousQuantity.val() === '' ? 0 : parseInt($previousQuantity.val());

                bookingQuantity += previousQuantity;
            });

            $bookingPreviousQuantity.text(bookingQuantity);

            $previousOverallInputs.each(function() {
                var $previousOverall = $(this),
                    previousOverall = $previousOverall.val() === '' ? 0 : parseInt($previousOverall.val());

                bookingOverall += previousOverall;
            });

            $bookingPreviousOverall.text(bookingOverall);

            if ($entryProgress.length > 0) {
                $entryProgress.each(function() {
                    var $progress = $(this),
                        $row = $progress.closest('tr'),
                        $progressOverall = $row.find('[data-form-control="overall"]'),
                        $progressSaleTickets = $row.find('[data-sale-tickets]'),
                        progressOverall = $progressOverall.val(),
                        saleTickets = $progressSaleTickets.data('sale-tickets');

                    if (progressOverall) {
                        var progress = (progressOverall / saleTickets) * 100,
                            roundFactor = Math.pow(10, 1),
                            roundProgress = Math.round(progress * roundFactor) / roundFactor;

                        $progress.text(roundProgress + ' %');
                    } else {
                        $progress.text('');
                    }
                });
            }

            $saleTickets.each(function() {
                bookingSaleTickets += parseInt($(this).data('sale-tickets'));
            });

            $bookingSaleTickets.text(bookingSaleTickets);

            var bookingPercent = (overallsSum / bookingSaleTickets) * 100;

            $bookingProgress
                .attr('data-percent', bookingPercent + '%')
                .trigger('progress');
        },

        onChangePeriodBegin: function() {
            var $periodBegin = $(this),
                $periodEnd = $('#representation_period_end');

            if ($periodBegin.val()) {
                if (! $periodEnd.val()) {
                    $periodEnd.val($periodBegin.val());
                } else if ($periodBegin.datepicker('getDate').getTime() > $periodEnd.datepicker('getDate').getTime()) {
                    $periodEnd.val($periodBegin.val());
                }
            } else {
                $periodEnd.trigger('change');
            }
        },

        onChangePeriodEnd: function() {
            var $periodEnd = $(this),
                $periodBegin = $('#representation_period_begin');

            if ($periodEnd.val()) {
                if (! $periodBegin.val()) {
                    $periodBegin.val($periodEnd.val());
                } else if ($periodEnd.datepicker('getDate').getTime() < $periodBegin.datepicker('getDate').getTime()) {
                    $periodBegin.val($periodEnd.val());
                }
            } else {
                $periodBegin.trigger('change');
            }
        },

        onChangePeriodAuto: function() {
            var $periodAuto = $(this),
                $periodBeginInput = $('#representation_period_begin'),
                $periodEndInput = $('#representation_period_end'),
                $periodBeginField = $periodBeginInput.closest('[data-form-field]'),
                $periodEndField = $periodEndInput.closest('[data-form-field]');

            if ($periodAuto.prop('checked')) {
                $periodBeginInput.val('');
                $periodEndInput.val('');
                $periodBeginField.toggleClass('hidden', true);
                $periodEndField.toggleClass('hidden', true);
            } else {
                $periodBeginInput.val($periodBeginInput.data('today'));
                $periodEndInput.val($periodBeginInput.data('today'));
                $periodBeginField.toggleClass('hidden', false);
                $periodEndField.toggleClass('hidden', false);
            }
        }
    };

    var $body = $('body');

    $body.on('app.init', function(ev) {
        var $container = $(ev.container),
            $form = $container.find('form[data-form="ticket-sales-register"]'),
            $periodBeginInputs = $('#representation_period_begin'),
            $periodEndInputs = $('#representation_period_end'),
            $periodAuto = $('#ticket_sales_register_representation_period_auto'),
            $quantityInputs = $form.find('[data-form-control="quantity"]'),
            $overallInputs = $form.find('[data-form-control="overall"]'),
            $bookingEntries = $form.find('[data-booking-entries]');

        $quantityInputs.on('change', _events.onChangeEntryQuantity);
        $overallInputs.on('change', _events.onChangeEntryOverall);
        $periodAuto.on('change', _events.onChangePeriodAuto);
        $periodBeginInputs.on('change', _events.onChangePeriodBegin);
        $periodEndInputs.on('change', _events.onChangePeriodEnd);
        $bookingEntries
            .on('refresh', _events.onRefreshBookingEntries)
            .trigger('refresh');
    });

}( require('jquery') ));
